<div class="px-5 py-7 otp-dialog md:h-full md:mt-0 mt-8 h-30rem justify-content-center flex align-items-center">
  <div [ngSwitch]="stage" class="w-30rem md:w-full">
    <ng-container *ngSwitchCase="'form'" [ngTemplateOutlet]="formTemplate"></ng-container>
    <ng-container *ngSwitchCase="'otp'" [ngTemplateOutlet]="otpTemplate"></ng-container>
    <ng-container *ngSwitchCase="'user_select'" [ngTemplateOutlet]="userSelectTemplate"></ng-container>
    <ng-container *ngSwitchCase="'ack'" [ngTemplateOutlet]="ackTemplate"></ng-container>
  </div>
</div>


<ng-template #formTemplate>
  <div class="p-d-flex p-flex-column p-ai-center">
    <div class="text-lg text-secondary-dark font-medium">To leave a note, please verify your account by sending an OTP first.</div>
  </div>

  <div class="p-fluid mt-5 sm:px-3">
    <form [formGroup]="formGroup">
      <div class="flex align-items-center gap-4">
        <label for="fullName" class="sm:w-3 w-4 text-sm text-right">Full Name</label>
        <input id="fullName" type="text" pInputText placeholder=" Enter Full name" class="p-1 px-3 custom-input" formControlName="full_name" />
      </div>

      <div class="field mt-4">
        <div class="flex align-items-center gap-4">
          <label for="fullName" class="sm:w-3 w-4 text-sm text-right">Phone #</label>
          <div class="flex w-full mobile-input">
            <div (click)="userVerificationCountry.toggle($event)" class="custom-input w-auto px-2 cursor-pointer flag-selection">
              <img [src]="selectedCountry.phone.flag" alt="flag" width="18" height="18">
            </div>
            <p-overlayPanel #userVerificationCountry styleClass="overlay-nav">
              <ul class="p-0 m-0 list-none">
                <li *ngFor="let i of countries"
                    class="cursor-pointer text-sm px-5 py-2 color-primary"
                    (click)="onCountrySelect(i, $event); userVerificationCountry.hide()">
                  {{ i.label }}
                </li>
              </ul>
            </p-overlayPanel>
            <div class="w-full">
              <p-inputMask
                id="phone"
                mask="(999)-999-9999"
                styleClass="custom-input number-input"
                formControlName="mobile"
                placeholder="(000) 000-0000"
                [unmask]="true">
              </p-inputMask>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="my-2 text-red text-center" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>

  <div class="flex justify-content-end mx-5 mt-8 mb-0 border-none gap-7 h-1rem">
    <div class="link-button" (click)="closeDialog(false)">
      Dismiss
    </div>
    <div class="link-button primary-blue" [class.disabled]="formGroup.invalid" (click)="send_otp()" *ngIf="!isLoading">
      Send
    </div>
    <ng-container *ngIf="isLoading">
      <p-progressSpinner [style]="{width: '25px', height: '25px'}" strokeWidth="8"></p-progressSpinner>
    </ng-container>
  </div>
</ng-template>

<ng-template #otpTemplate>
  <div class="p-d-flex p-flex-column p-ai-center">
    <div class="text-lg text-secondary-dark font-medium text-center">
      <div>Enter OTP sent to your mobile</div>
      <div>
        {{ formGroup.get('phone')?.value }}
      </div>
    </div>
  </div>

  <div class="p-fluid mt-5 sm:px-3">
    <div class="flex justify-content-center">
      <div>
        <!-- Time SVG -->
        <div>
          <img src="assets/images/otp-timer.svg" alt="">
        </div>
        <!-- Time Counter -->
        <div class="mt-2 text-gray text-md">
          {{timerString}}
        </div>

      </div>

    </div>

    <div class="flex justify-content-center">
      <div class="mt-4">
        <p-inputMask
            mask="9 9 9 9"
            placeholder="0-0-0-0"
            slotChar="_ _ _ _"
            styleClass="text-3xl p-2 px-3 otp-input"
            [formControl]="otpFormControl"
            [unmask]="true">
          </p-inputMask>

          <div class="mt-2 text-gray text-sm text-center">
            Enter OTP
          </div>
      </div>
    </div>
  </div>

  <div class="my-2 text-red text-center" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>

  <div class="flex justify-content-evenly mx-5 mt-8 mb-0 border-none">

    <div class="link-button" (click)="stage = 'form'">Change Number</div>
    <ng-container *ngIf="timerString !== '00:00'">
      <div class="link-button primary-blue" *ngIf="!isLoading" [class.disabled]="otpFormControl.value?.length !== 4" (click)="verify_otp()">Submit</div>
      <ng-container *ngIf="isLoading">
        <p-progressSpinner [style]="{width: '25px', height: '25px'}" strokeWidth="8"></p-progressSpinner>
      </ng-container>
    </ng-container>
    <div class="link-button primary-blue" *ngIf="timerString === '00:00' && !isLoading" (click)="send_otp()">Resend</div>

  </div>
</ng-template>


<ng-template #userSelectTemplate>
  <div class="p-d-flex p-flex-column p-ai-center">
    <div class="text-lg text-secondary-dark font-medium text-center">
      <div>Choose the account to <br> leave a note.</div>
    </div>
  </div>

  <div class="p-fluid mt-5 sm:px-3 user-select">
    <div class="text-md text-secondary-dark">
      <div class="font-medium mb-3">Your Accounts</div>
      <div class="account-card my-2" *ngFor="let user of userList" (click)="userTypeFormControl.setValue(user)">
        <div class="flex align-items-center p-3 gap-3">
          <div>
            <img class="border-circle h-3rem w-3rem bg-cover" [src]="user.profile_picture || 'assets/images/person.svg'" alt="">
          </div>
          <div class="text-gray6 text-gray6">
            <div class="text-md font-medium">{{ user?.user_type_name }} Account</div>
            <div class="text-sm mt-1"> {{ user?.first_name }} {{ user?.last_name }} </div>
          </div>
          <div class="ml-auto">
          <p-radioButton
            [value]="user"
            [formControl]="userTypeFormControl" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="my-2 text-red text-center" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>

  <div class="flex justify-content-evenly mx-5 mt-8 mb-0 border-none">

    <div class="link-button" (click)="stage = 'form'">Change Number</div>
    <div class="link-button primary-blue" [class.disabled]="!userTypeFormControl.value" (click)="selectUser()">Select</div>

  </div>
</ng-template>


<ng-template #ackTemplate>
  <div class="p-d-flex p-flex-column p-ai-center">
    <div class="text-lg text-secondary-dark font-medium text-center">
      <div> Hi, <span *ngIf="userDetail">{{ userDetail.first_name }} {{userDetail.last_name}}</span>! </div>
      <div> Verification complete. </div>
      <div class="mt-5"> You're ready to proceed. </div>
    </div>
  </div>

  <div class="flex justify-content-evenly mt-8 mx-5 border-none">
    <div class="link-button primary-blue" (click)="closeDialog(true)">Ok</div>
  </div>
</ng-template>
